export default "__VITE_ASSET__tiGtXPPa__"